export default __webpack_public_path__ + "static/media/01-empathize.6e37d0e5.svg";